/** @jsx jsx */
import { SingleSelect, SingleSelectProps } from "@eworkit/iris";
import { FC, useCallback } from "react";
import { jsx } from "theme-ui";

import { withFormikField } from "@/components/Formik";
import { fetchCodelist, ICodelist, TCodelistName } from "@/data/codelists";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { useFetcher } from "@/hooks/http";

interface CodelistSingleSelectProps {
  codelistName: TCodelistName;
  value?: string | null;
  onChange?: (value?: string) => void;
  size?: SingleSelectProps["size"];
  disabled?: boolean;
  searchable?: boolean;
  clearable?: boolean;
}

export const CodelistSingleSelect: FC<CodelistSingleSelectProps> = ({
  codelistName,
  value,
  onChange,
  ...selectProps
}) => {
  const tCodelist = useCodelistTranslation();

  const fetcher = useFetcher<{}, ICodelist[]>(fetchCodelist, { codelistName }, []);

  const handleChange = useCallback(
    (newValue?: ICodelist) => {
      onChange?.(newValue?.code);
    },
    [onChange],
  );

  return (
    <SingleSelect
      options={fetcher.payload}
      value={fetcher.payload?.find(o => o.code === value)}
      onChange={handleChange}
      labelSelector={o => tCodelist(codelistName, o.code)}
      identifierSelector={o => o.code}
      working={fetcher.working}
      {...selectProps}
    />
  );
};

export const FormikCodelistSingleSelect = withFormikField(CodelistSingleSelect);
